import * as rq from '@tanstack/react-query';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace GetPerformanceWarrantyStates {
  export const key = (input: Input, repository: IWarrantyRepository) => [
    'warranty',
    'get-performance-warranty-states',
    repository.key,
    input.assetFullFrontendId,
    input.customerId,
  ];

  export type Params = { refetchInterval?: number };
  export type Input = IWarrantyRepository.GetPerformanceWarrantyStatesInput;
  export type Output = IWarrantyRepository.GetPerformanceWarrantyStatesOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input, repositories.warranty),
      queryFn: () => repositories.warranty.getPerformanceWarrantyStates(input),
    });
  }
}
